import { useCallback } from "react";

import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";

export default function ActionMenuLinkItem(props) {
  const {
    url,
  } = props;

  const handleClick = useCallback((_event) => {
    window.open(url, "_blank");
  }, [url]);

  /**************************************************************************************************/

  return (
    <ActionMenuBaseItem
      onClick={handleClick}
      {...props}
    />
  );
}
